import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, initialize, Field } from 'redux-form';
import { Input } from 'components/Input';
import { api } from 'utils/api';
import { get } from 'lodash';
import { websiteSelector } from 'selectors';
import { changeWebsite } from 'actions';
import { Form } from 'components/Form';
import { useTranslation } from 'react-i18next';

const formName = 'EditCorporateTubeAssets';

export function Assets(props) {
  const { t } = useTranslation();
  return (
    <Form {...props} formTitle="assets">
      <Field name="domain" title={t('assetsDomain')} component={Input} description={t('assetsDomainDescription')} />
    </Form>
  );
}

const changeWebsiteApi = (id) => (dispatch) => (assets) => {
  return api.patch(`/websites/${id}`, { assets }).then((payload) => {
    dispatch(initialize(formName, payload.assets));
    dispatch(changeWebsite(payload));
  });
};

export const AssetsDecorated = compose(
  connect(
    (state) => ({
      website: websiteSelector(state),
      formName,
    }),
    {
      changeWebsiteApi,
    },
    (stateProps, dispatchProps, ownProps) => {
      const domain = get(stateProps.website, 'assets.domain');
      return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        initialValues: { domain },
        onSubmit: dispatchProps.changeWebsiteApi(get(stateProps.website, 'id')),
      };
    }
  ),
  reduxForm({
    form: formName,
    enableReinitialize: false,
  })
)(Assets);
